// Segmented switch: Active | Archived on the spaces list, People | Settings
// inside a space. `options` is [{ value, label, count }]; a count renders at
// reduced emphasis after its label. aria-pressed marks the selected segment, so
// a screen reader hears the choice as well as seeing the fill.
export default function Segmented({ label, value, onChange, options }) {
  return (
    <div className="segmented" role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="segmented__item"
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
          {option.count !== undefined && <span className="segmented__count">{option.count}</span>}
        </button>
      ))}
    </div>
  )
}
